export var CampaignTabs;
(function (CampaignTabs) {
    CampaignTabs["Details"] = "DETAILS";
    CampaignTabs["Summary"] = "SUMMARY";
})(CampaignTabs || (CampaignTabs = {}));
export var CampaignSubmissionTemplateKind;
(function (CampaignSubmissionTemplateKind) {
    CampaignSubmissionTemplateKind["SUBMITTED"] = "submitted";
    CampaignSubmissionTemplateKind["DATA_EXPORT"] = "dataExport";
})(CampaignSubmissionTemplateKind || (CampaignSubmissionTemplateKind = {}));
